import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M12 5a6.365 6.365 0 0 0-8.188-.687A1.98 1.98 0 0 0 3 5.93v12.956c0 .774.825 1.223 1.508.859A6.365 6.365 0 0 1 12 20.864za6.365 6.365 0 0 1 8.188-.687c.518.369.812.98.812 1.617v12.956c0 .774-.825 1.224-1.508.859A6.365 6.365 0 0 0 12 20.864",
      stroke: "black",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }